<!--
<div class="row py-5" [dir]="this.apiService.currentDirection">
  <div class="container whiteSection text-justify py-5">
<h2 class="py-2">ماموریت</h2>
    <p>ماموریت الوبدو ایجاد رابطه ای قابل اعتماد بین مشتریان و متخصصین خدمات انلاین می  باشد. کمک به مشتری در جهت دریافت خدمات سیاری که به موقع و توسط متخصصین حرفه ای و با تجربه انجام شود نیز از ماموریت  های مهم الوبدو است. ساماندهی و یکپارچه سازی خدمات انلاین، کاهش هزینه  های مشتری در دریافت خدمات شخصی و منزل و کمک به کسب درآمد برای متخصصین خدمات سیار و همچنین کمک به خروج از فضای سنتی و ورود به فضای مدرن و به روز از ماموریت  های دیگر الوبدو است. </p>

 <h2 class="py-2">چشم انداز</h2>
    <p>علاوه بر ساماندهی و یکپارچه  سازی خدمات آنلاین در کلان شهرهای ایران از جمله شیراز در افق کوتاه مدت و در افق بلند مدت معرفی و استفاده از اپلیکیشن الوبدو در سطح جهانی یکی از چشم اندازهای الوبدواست.  تیم متخصص و جوان الوبدو با تلاش شبانه روزی در صدد ایجاد فضایی برای برقراری ارتباط موثر و قوی بین مشتریان و متخصصین خدمات زیر است.   </p>
    <ol>
      <li>خدمات خودرو و وسایل نقلیه سبک و سنگین</li>
      <li>دوچرخه و موتور سیکلت</li>
      <li>	آرایش و پیرایش</li>
      <li>خدمات درمانی، پزشکی و دامپزشکی</li>
      <li>موبایل و کامپیوتر</li>
      <li>هنر</li>
      <li>آموزش</li>
      <li>توریست و گردشگری</li>
      <li>حمل و نقل و اسباب کشی</li>
      <li>خدمات رایانه ای و ماشین های اداری</li>
      <li>مراسم و جشن های عروسی</li>
      <li>...</li>
    </ol>
  </div>
</div> -->


<div class="container py-5 position-relative" style="min-height: 300px" [dir]="this.apiService.currentDirection">
  <div class="loader" *ngIf="loader"></div>
  <div *ngIf="!loader">


    <div class="sidenav"
      [ngStyle]="{'left':this.apiService.currentDirection==='ltr'?0:null,'right':this.apiService.currentDirection==='rtl'?0:null}">
      <a *ngFor="let item of categories" (click)="ScrollIntoView('#category'+item.id)">
        <img [src]="item.iconImage" class="miniIcon" />
        {{item.title}}</a>
    </div>

    <div class="main "
      [ngClass]="{'marginLeft':this.apiService.currentDirection==='ltr','marginRight':this.apiService.currentDirection==='rtl'}">
      <div *ngFor="let item of categories" style="padding-top: 30px;" id="{{'category'+item.id}}">
        <h4 class="my-3 mt-5">{{item.title}}</h4>
        <!--      <div class="row col-12 col-md-12">-->
        <!-- [routerLink]="['/service-description/'+subcat.id]" -->
        <div class="row my-3 content">
          <!-- <div class="card" style="cursor: pointer" *ngFor="let subcat of item.subCategoies"
            [ngStyle]="{'cursor':subcat.isActive? 'pointer':'default'}"
            [routerLink]="subcat.isActive ? ['/service-description/'+subcat.id] : []"
            (click)="internalService.setIsLeafTrue()"> -->

            <div class="card" style="cursor: pointer" *ngFor="let subcat of item.subCategoies"
            [routerLink]="['/service-description/'+subcat.id]"
            (click)="internalService.setIsLeafTrue()">

          <div>
            <img class="cardImage" *ngIf="subcat.base64" [src]="subcat.base64" [alt]="subcat.imageAlt">
            </div>
            
            <!-- <div class="cardImage" *ngIf="subcat.base64" [style.background-image]="'url(' + subcat.base64 + ')'">

            </div> -->
            <div class="cardImage " *ngIf="!subcat.base64"
              [ngClass]="apiService.currentDirection==='rtl'?'comingSoonFa':'comingSoonEn'">
            </div>
            <!--            <img [src]="subcat.base64" [title]="subcat.title" >-->
            <div class="container my-2">
              <span
                [ngStyle]="{'text-align':this.apiService.currentDirection === 'rtl'? 'right':'left'}">{{subcat.title}}
              </span>
            </div>
          </div>
        </div>
        <!--      </div>-->
        <div class="row mt-2">

          <p class="col-6" style="margin-bottom: 0.8rem;   color: #818181;" *ngFor="let skill of item.skills"
            [ngStyle]="{'cursor':skill.isActive? 'pointer':'default','color':skill.isActive? '#000':'rgb(129, 129, 129);'}"
            [routerLink]="skill.isActive ? ['/service-description/'+skill.categoryId] : []"
            (click)="internalService.setIsLeafTrue()">{{skill.title}}</p>

        </div>
        <hr />
      </div>
    </div>

  </div>


</div>